import { OKShareButton, VKShareButton, TelegramShareButton } from 'react-share';
import { OkIcon, TgIcon, VkIcon } from "@kursk/components/ui/icons";
import styles from './SocialLinks.module.scss';
import { useEffect, useState } from "react";

export const SocialLinks = () => {

  const [shareUrl, setShareUrl] = useState(null);

  useEffect(() => {
    setShareUrl(window.location.href);
  }, []);

  return (
    <div className={styles.wrapper}>
      <VKShareButton
        url={shareUrl}
        className={styles.socButton}
      ><VkIcon width={18}/>
      </VKShareButton>
      <OKShareButton
        url={shareUrl}
        className={styles.socButton}
      >
        <OkIcon/>
      </OKShareButton>
      <TelegramShareButton
        url={shareUrl}
        className={styles.socButtonTg}
      >
        <TgIcon />
      </TelegramShareButton>
    </div>
  )
}
